<template>
  <div class="room-info">
    <modal-header>Customise</modal-header>

    <form @submit.prevent="">
      <div class="form-group">
        <TextInput
          ref="roomNameInput"
          inset
          large
          label="Name the Room"
          placeholder="Enter your room name"
          v-model="name"
        />
        <p class="input__error" v-if="error.name">{{ error.name }}</p>
      </div>
      <div v-if="ifHasLink" class="form-group">
        <TextInput :label="linkType" inset placeholder="Enter Room Link" v-model="link"/>
        <p class="input__error" v-if="error.url">{{error.url}}</p>
      </div>

      <CustomiseSection
        :startAngle="angle"
        :updateAngle="updateAngle"
        :backgroundColour="backgroundColour"
        :updateBackground="updateBackground"
        :backgroundImage="backgroundImage"
        :newImageUploaded="newImageUploaded"
        :imageRemoved="imageRemoved"
        :showName="showName"
        :updateShowName="updateShowName"
        :textColor="textColor"
        :updateTextColour="updateTextColour"
      />

      <FooterButtons>
        <btn @onClick="cancel()" colour="ghost">
          <template #text>Cancel</template></btn>
        <btn @onClick="submit" :disabled="!isValid || !dirty" colour="green"> <template #text>Save</template></btn>
      </FooterButtons>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { TextInput, FooterButtons } from "@/framework"
import ModalHeader from '@/framework/modals/components/newModalHeader.vue';
import FormChangeWatcherMixin from "@/plugins/mixins/formChangeWatcher.js";
import CustomiseSection from './CustomiseSection.vue'


export default {
  name: 'CustomiseRoomModal',
  components: { ModalHeader, TextInput, FooterButtons, CustomiseSection },
  data: (vm) => ({
    error: {
      name: ''
    },

    name: vm.$store.getters.getSpaceName,
    backgroundImage: vm.$store.getters.getSpaceImage,
    backgroundColour: vm.$store.getters.getSpaceColour,
    textColor: vm.$store.getters.getSpaceTextColor || 'white',
    showName: !vm.$store.getters.getSpaceHideName,
    link: vm.$store.getters.getSpaceJoinLink,
    angle: vm.$store.getters.getSpaceBaseAngle,

    formChangeWatcherSettings: {
      // This tells FormChangeWatcherMixin to watch these inputs
      // so we know when to present the "Save" button
      inputs: [
        "backgroundColour",
        "backgroundImage",
        "name",
        "textColor",
        "showName",
        "link",
        "angle"
      ],

      defaults: {
        backgroundColour: '',
        backgroundImage: '',
        name: '',
        textColor: '',
        showName: true,
        link: '',
        angle: 0,
      },

      promptOnLeave: false
    },
  }),
  mixins: [ FormChangeWatcherMixin ],
  computed: {
    ...mapGetters({
      confType: 'getSpaceConferenceType'
    }),
    isValid() {
      if (!this.name) return false
      return true
    },
    ifHasLink() {
      let linkTypes = ['livestream', 'link', 'internal']
      return linkTypes.includes(this.confType)
    },
    linkType() {
      switch(this.confType) {
        case 'livestream':
          return 'Livestream Link'
        case 'link':
          return 'External Link'
        case 'internal':
          return 'Embedded Link'
        default:
          return 'Link'
      }
    }
  },
  watch: {
    name() {
      this.error.name = !this.name ? "Room name is required" : "";
    },
    link(){
      this.error.url = !this.link && this.linkType ? "Room Link is required" : "";
    },
  },
  methods: {
    ...mapActions(['handleCustomizeRoom', 'modal/close']),
    cancel() {
    this['modal/close']()
    },
    async submit() {
      await this.handleCustomizeRoom([this.name, this.backgroundColour, this.backgroundImage, this.textColor, !this.showName, this.link, this.angle]);
      this['modal/close']();
    },
    // customise handlers
    newImageUploaded(url) {
      this.backgroundImage = url
    },
    imageRemoved() {
      this.backgroundImage = ""
    },
    updateBackground(val) {
      this.backgroundColour = val
    },
    updateTextColour(val) {
      this.textColor = val
    },
    updateShowName(val) {
      this.showName = val
    },
    updateAngle(a) {
      this.angle = a.value
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "~@/scss/components/modals/modal_forms.scss";
@import '~@/scss/components/modals/create_room_form.scss';
</style>
